(function (global) {
  'use strict';

  document.addEventListener('submit', function (event) {
    var card = event.target.closest && event.target.closest('product-card[data-vl-extra-purchase-selected]');
    if (!card) return;
    var freeItemHost = event.target.closest('.product-card-2-form[data-freeitem]');
    if (!freeItemHost) return;
    var freeItemValue = freeItemHost.getAttribute('data-freeitem');
    freeItemHost.setAttribute('data-freeitem', '');
    window.setTimeout(function () {
      if (freeItemValue == null) freeItemHost.removeAttribute('data-freeitem');
      else freeItemHost.setAttribute('data-freeitem', freeItemValue);
    }, 0);
  }, true);

  // Product Card option availability follows the product's option-order funnel.

  function toIdSet(ids) {
    return new Set((ids || []).map(function (id) { return String(id); }));
  }

  function getVisibleVariants(variants, hiddenVariantIds) {
    var hiddenIds = hiddenVariantIds instanceof Set ? hiddenVariantIds : toIdSet(hiddenVariantIds);
    return (variants || []).filter(function (variant) {
      return !hiddenIds.has(String(variant.id));
    });
  }

  function getHiddenVariants(variants, hiddenVariantIds) {
    var hiddenIds = hiddenVariantIds instanceof Set ? hiddenVariantIds : toIdSet(hiddenVariantIds);
    return (variants || []).filter(function (variant) {
      return hiddenIds.has(String(variant.id));
    });
  }

  function normalize(value) {
    return String(value == null ? '' : value).toLocaleLowerCase().replace(/\s+/g, '');
  }

  function getOptionNameAliases(value) {
    var original = String(value == null ? '' : value).trim();
    var aliases = [normalize(original)];
    var parenthesized = original.match(/[\(（]([^\)）]+)[\)）]\s*$/);
    if (parenthesized && parenthesized[1]) aliases.push(normalize(parenthesized[1]));
    return Array.from(new Set(aliases.filter(Boolean)));
  }

  function prepareExtraPurchaseRecords(records) {
    var groups = new Map();

    (records || []).forEach(function (record) {
      var targetOption = String(record.targetOption || '').trim();
      var targetOptionNormalized = normalize(targetOption);
      if (!targetOptionNormalized || !Array.isArray(record.products)) return;

      if (!groups.has(targetOptionNormalized)) {
        groups.set(targetOptionNormalized, {
          targetOption: targetOption,
          targetOptionNormalized: targetOptionNormalized,
          products: [],
          productIds: new Set()
        });
      }

      var group = groups.get(targetOptionNormalized);
      record.products.forEach(function (product) {
        var productId = String(product.id || '');
        if (!productId) return;
        if (group.productIds.has(productId)) {
          var existingProduct = group.products.find(function (item) {
            return String(item.id) === productId;
          });
          if (existingProduct && record.isPurchaseFirst === true) {
            existingProduct.isPurchaseFirst = true;
          }
          return;
        }
        group.productIds.add(productId);
        product.isPurchaseFirst = record.isPurchaseFirst === true;
        product.hiddenVariants = getHiddenVariants(product.variants, product.hiddenVariantIds);
        product.variants = getVisibleVariants(product.variants, product.hiddenVariantIds);
        product.optionIndexes = new Map();
        (product.optionNames || []).forEach(function (optionName, index) {
          getOptionNameAliases(optionName).forEach(function (alias) {
            product.optionIndexes.set(alias, index);
          });
        });
        group.products.push(product);
      });
    });

    groups.forEach(function (group) {
      group.products = group.products.filter(function (product) {
        return product.isPurchaseFirst === true;
      }).concat(group.products.filter(function (product) {
        return product.isPurchaseFirst !== true;
      }));
    });

    return Array.from(groups.values());
  }

  function findDefaultExtraPurchase(records, optionNames, selectedOptions, config) {
    for (var recordIndex = 0; recordIndex < (records || []).length; recordIndex += 1) {
      var record = records[recordIndex];
      for (var productIndex = 0; productIndex < record.products.length; productIndex += 1) {
        var product = record.products[productIndex];
        if (product.isPurchaseFirst !== true) continue;
        var matches = findPurchaseFunnelVariants(
          product,
          record,
          optionNames,
          selectedOptions,
          config,
          false
        );
        var variant = findPreferredAvailableVariant(
          matches,
          optionNames,
          selectedOptions,
          product.optionIndexes,
          record.targetOptionNormalized
        );
        if (variant) return { record: record, product: product, variant: variant };
      }
    }
    return null;
  }

  function selectedOptionsByNormalizedName(optionNames, selectedOptions) {
    return (optionNames || []).reduce(function (result, optionName) {
      result.set(normalize(optionName), selectedOptions[optionName]);
      return result;
    }, new Map());
  }

  function findMatchingPurchaseVariants(product, targetOptionNormalized, optionNames, selectedOptions, overrides, variants) {
    var selected = selectedOptionsByNormalizedName(optionNames, selectedOptions);
    var overrideValues = overrides || new Map();

    return (variants || product.variants || []).filter(function (variant) {
      return Array.from(product.optionIndexes.entries()).every(function (entry) {
        var normalizedName = entry[0];
        var optionIndex = entry[1];
        if (normalizedName === targetOptionNormalized || !selected.has(normalizedName)) return true;
        var expected = overrideValues.has(normalizedName)
          ? overrideValues.get(normalizedName)
          : selected.get(normalizedName);
        return normalize(variant['option' + (optionIndex + 1)]) === normalize(expected);
      });
    });
  }

  function normalizeInitialVariant(variants, requestedId) {
    if (!Array.isArray(variants) || variants.length === 0) return null;

    var normalizedId = String(requestedId || '');
    return variants.find(function (variant) {
      return String(variant.id) === normalizedId;
    }) || variants.find(function (variant) {
      return variant.available;
    }) || variants[0];
  }

  function selectedOptionsFromVariant(optionNames, variant) {
    return (optionNames || []).reduce(function (selectedOptions, optionName, index) {
      selectedOptions[optionName] = variant ? variant['option' + (index + 1)] : null;
      return selectedOptions;
    }, {});
  }

  function findExactVariant(variants, optionNames, selectedOptions) {
    return (variants || []).find(function (variant) {
      return (optionNames || []).every(function (optionName, index) {
        return variant['option' + (index + 1)] === selectedOptions[optionName];
      });
    }) || null;
  }

  function findFallbackVariant(variants, optionNames, selectedOptions, changedOptionName) {
    if (!Array.isArray(variants) || variants.length === 0) return null;

    var changedIndex = optionNames.indexOf(changedOptionName);
    var preferredIndexes = [];
    if (optionNames.length > 0) preferredIndexes.push(0);
    if (changedIndex > 0) preferredIndexes.push(changedIndex);

    for (var i = 0; i < preferredIndexes.length; i += 1) {
      var optionIndex = preferredIndexes[i];
      var optionName = optionNames[optionIndex];
      var selectedValue = selectedOptions[optionName];
      var match = variants.find(function (variant) {
        return variant['option' + (optionIndex + 1)] === selectedValue;
      });
      if (match) return match;
    }

    return variants[0];
  }

  function getOptionState(variants, optionNames, selectedOptions, optionName, value) {
    var optionIndex = optionNames.indexOf(optionName);
    if (optionIndex < 0) return { selected: false, exists: false, available: false };

    var matches = (variants || []).filter(function (variant) {
      return optionNames.every(function (candidateName, candidateIndex) {
        if (candidateIndex === optionIndex) {
          return variant['option' + (candidateIndex + 1)] === value;
        }
        return variant['option' + (candidateIndex + 1)] === selectedOptions[candidateName];
      });
    });

    return {
      selected: selectedOptions[optionName] === value,
      exists: matches.length > 0,
      available: matches.some(function (variant) { return variant.available; })
    };
  }

  function isColorOptionName(optionName) {
    var normalizedName = normalize(optionName);
    return normalizedName.indexOf('color') !== -1 || normalizedName.indexOf('colour') !== -1;
  }

  function getMappedOptionIndex(optionName, optionNames, optionIndexes) {
    if (!optionIndexes) return optionNames.indexOf(optionName);

    var aliases = getOptionNameAliases(optionName);
    for (var aliasIndex = 0; aliasIndex < aliases.length; aliasIndex += 1) {
      if (optionIndexes.has(aliases[aliasIndex])) return optionIndexes.get(aliases[aliasIndex]);
    }
    return -1;
  }

  function hasMappedOption(optionName, optionNames, optionIndexes) {
    return getMappedOptionIndex(optionName, optionNames, optionIndexes) >= 0;
  }

  function getFunnelConstraintNames(optionNames, optionName) {
    var optionIndex = optionNames.indexOf(optionName);
    if (optionIndex <= 0) return [];

    if (isColorOptionName(optionName)) {
      return optionNames.filter(function (candidateName, candidateIndex) {
        return candidateIndex !== optionIndex && !isColorOptionName(candidateName);
      });
    }

    return optionNames.slice(0, optionIndex);
  }

  function findFunnelVariants(
    variants,
    optionNames,
    selectedOptions,
    optionName,
    optionValue,
    optionIndexes,
    skipCandidate
  ) {
    var mappedOptionIndex = getMappedOptionIndex(optionName, optionNames, optionIndexes);
    if (!skipCandidate && mappedOptionIndex < 0) return [];

    var constraintNames = getFunnelConstraintNames(optionNames, optionName);
    return (variants || []).filter(function (variant) {
      if (
        !skipCandidate
        && normalize(variant['option' + (mappedOptionIndex + 1)]) !== normalize(optionValue)
      ) {
        return false;
      }

      return constraintNames.every(function (constraintName) {
        var constraintIndex = getMappedOptionIndex(constraintName, optionNames, optionIndexes);
        if (constraintIndex < 0) return true;
        return normalize(variant['option' + (constraintIndex + 1)]) === normalize(selectedOptions[constraintName]);
      });
    });
  }

  function findOptionNameByNormalizedValue(optionNames, normalizedName) {
    return (optionNames || []).find(function (optionName) {
      return normalize(optionName) === normalizedName;
    }) || null;
  }

  function filterVariantsByProductRules(variants, optionNames, selectedOptions, config, optionIndexes) {
    if (!config || selectedOptions.Style !== 'High-Step') return variants;

    var sizeIndex = getMappedOptionIndex('Size', optionNames, optionIndexes);
    if (sizeIndex < 0) return variants;

    if (config.highStepForcesLarge) {
      return variants.filter(function (variant) {
        return variant['option' + (sizeIndex + 1)] === 'Large';
      });
    }
    if (config.disableRegularForHighStep) {
      return variants.filter(function (variant) {
        return variant['option' + (sizeIndex + 1)] !== 'Regular';
      });
    }
    return variants;
  }

  function findFunnelVariantsForState(state, optionName, optionValue, selectedOptions, hidden) {
    var purchase = state.currentPurchase;
    var normalizedOptionName = normalize(optionName);
    var usePurchase = Boolean(
      purchase
      && normalizedOptionName !== purchase.record.targetOptionNormalized
      && hasMappedOption(optionName, state.config.optionNames, purchase.product.optionIndexes)
    );
    var variants = usePurchase
      ? (hidden ? purchase.product.hiddenVariants : purchase.product.variants)
      : (hidden ? state.hiddenVariants : state.variants);
    var optionIndexes = usePurchase ? purchase.product.optionIndexes : null;
    var matches = findFunnelVariants(
      variants,
      state.config.optionNames,
      selectedOptions,
      optionName,
      optionValue,
      optionIndexes,
      false
    );
    return filterVariantsByProductRules(
      matches,
      state.config.optionNames,
      selectedOptions,
      state.config,
      optionIndexes
    );
  }

  function findPurchaseFunnelVariants(product, record, optionNames, selectedOptions, config, hidden) {
    var targetOptionName = findOptionNameByNormalizedValue(
      optionNames,
      record.targetOptionNormalized
    );
    if (!targetOptionName) return [];

    var matches = findFunnelVariants(
      hidden ? product.hiddenVariants : product.variants,
      optionNames,
      selectedOptions,
      targetOptionName,
      null,
      product.optionIndexes,
      true
    );
    return filterVariantsByProductRules(
      matches,
      optionNames,
      selectedOptions,
      config,
      product.optionIndexes
    );
  }

  function findPreferredAvailableVariant(
    variants,
    optionNames,
    selectedOptions,
    optionIndexes,
    ignoredOptionNormalized
  ) {
    var availableVariants = (variants || []).filter(function (variant) {
      return variant.available;
    });
    if (availableVariants.length === 0) return null;

    return availableVariants.find(function (variant) {
      return (optionNames || []).every(function (optionName) {
        if (normalize(optionName) === ignoredOptionNormalized) return true;
        var optionIndex = getMappedOptionIndex(optionName, optionNames, optionIndexes);
        if (optionIndex < 0 || selectedOptions[optionName] == null) return true;
        return normalize(variant['option' + (optionIndex + 1)]) === normalize(selectedOptions[optionName]);
      });
    }) || availableVariants[0];
  }

  function mergeSelectedOptionsFromPurchaseVariant(
    optionNames,
    selectedOptions,
    product,
    variant,
    targetOptionNormalized
  ) {
    return (optionNames || []).reduce(function (nextOptions, optionName) {
      if (normalize(optionName) === targetOptionNormalized) return nextOptions;
      var optionIndex = getMappedOptionIndex(optionName, optionNames, product.optionIndexes);
      if (optionIndex >= 0) nextOptions[optionName] = variant['option' + (optionIndex + 1)];
      return nextOptions;
    }, Object.assign({}, selectedOptions));
  }

  function getOptionStateForState(state, optionName, value, selectedOptions) {
    var nextSelectedOptions = applyProductRules(
      selectedOptions || state.selectedOptions,
      optionName,
      value,
      state.config
    );
    var matches = findFunnelVariantsForState(
      state,
      optionName,
      value,
      nextSelectedOptions,
      false
    );
    var hiddenMatches = findFunnelVariantsForState(
      state,
      optionName,
      value,
      nextSelectedOptions,
      true
    );

    return {
      selected: state.selectedOptions[optionName] === value,
      exists: matches.length > 0,
      available: matches.some(function (variant) { return variant.available; }),
      hiddenExists: hiddenMatches.length > 0,
      matches: matches,
      selectedOptions: nextSelectedOptions
    };
  }

  function applyProductRules(selectedOptions, optionName, value, config) {
    var nextOptions = Object.assign({}, selectedOptions, (function () {
      var selected = {};
      selected[optionName] = value;
      return selected;
    })());

    if (config && config.highStepForcesLarge && value === 'High-Step') {
      nextOptions.Size = 'Large';
    }
    return nextOptions;
  }

  function isOptionDisabledByRule(optionName, optionValue, variant, config) {
    return Boolean(
      config &&
      config.disableRegularForHighStep &&
      optionName === 'Size' &&
      optionValue === 'Regular' &&
      variant &&
      variant.option1 === 'High-Step'
    );
  }

  function isOptionElementDisabled(optionElement) {
    if (!optionElement) return true;
    return optionElement.disabled === true
      || optionElement.getAttribute('aria-disabled') === 'true'
      || optionElement.classList.contains('disabled');
  }

  function formatMoney(cents) {
    return '$' + ((Number(cents) || 0) / 100).toLocaleString();
  }

  function variantUrl(productUrl, variantId, existingUrl) {
    var sourceUrl = existingUrl || productUrl;
    try {
      var parsedUrl = new URL(sourceUrl, 'https://velotric.invalid');
      parsedUrl.searchParams.set('variant', String(variantId));
      if (/^https?:\/\//.test(sourceUrl)) return parsedUrl.href;
      return parsedUrl.pathname + parsedUrl.search + parsedUrl.hash;
    } catch (error) {
      var separator = productUrl.indexOf('?') === -1 ? '?' : '&';
      return productUrl + separator + 'variant=' + variantId;
    }
  }

  function variantImageUrl(variant, fallbackImageUrl) {
    var imageUrl = variant && variant.featured_image && variant.featured_image.src;
    if (!imageUrl) return fallbackImageUrl || '';
    if (/[?&]width=/.test(imageUrl)) return imageUrl;
    return imageUrl + (imageUrl.indexOf('?') === -1 ? '?' : '&') + 'width=800&height=600&format=webp';
  }

  function setText(element, value) {
    if (element) element.textContent = value;
  }

  function setHidden(element, hidden) {
    if (!element) return;
    element.hidden = hidden;
    element.classList.toggle('hidden', hidden);
  }

  function renderVariant(root, state) {
    var variant = state.currentVariant;
    var config = state.config;
    var activeProduct = state.currentPurchase && state.currentPurchase.product;
    var fallbackImageUrl = activeProduct && activeProduct.featuredImageUrl
      ? activeProduct.featuredImageUrl
      : config.fallbackImageUrl;
    var targetVariant = findExactVariant(state.variants, config.optionNames, state.selectedOptions)
      || state.variants[0];
    var imageUrl = variantImageUrl(variant, fallbackImageUrl);
    var compareAtPrice = Number(variant.compare_at_price) || 0;
    var price = Number(variant.price) || 0;
    var saveCents = Math.max(compareAtPrice - price, 0)
      + (activeProduct ? 0 : (Number(config.freeItemValueCents) || 0));
    var soldOutText = global.auroraThemeLocales
      && global.auroraThemeLocales.variantStrings
      && global.auroraThemeLocales.variantStrings.soldOut;

    root.dataset.variant = String(variant.id);
    root.toggleAttribute('data-vl-extra-purchase-selected', Boolean(activeProduct));
    if (activeProduct) root.dataset.vlPurchaseProductId = String(activeProduct.id);
    else delete root.dataset.vlPurchaseProductId;
    if (config.optionNames.length > 1) root.dataset.styleValue = state.selectedOptions[config.optionNames[0]] || '';
    if (config.optionNames.length > 2) root.dataset.sizeValue = state.selectedOptions[config.optionNames[1]] || '';

    root.querySelectorAll('[data-vpc-link]').forEach(function (link) {
      link.href = variantUrl(config.productUrl, targetVariant.id, config.productUrl);
    });
    root.querySelectorAll('[data-vpc-image]').forEach(function (image) {
      if (!imageUrl) return;
      image.src = imageUrl;
      image.setAttribute('data-src', imageUrl);
    });
    root.querySelectorAll('[data-vpc-price]').forEach(function (priceElement) {
      setText(priceElement, formatMoney(price));
    });
    root.querySelectorAll('[data-vpc-compare-price]').forEach(function (compareElement) {
      setText(compareElement, formatMoney(compareAtPrice));
      setHidden(compareElement, compareAtPrice <= price);
    });
    root.querySelectorAll('[data-vpc-save]').forEach(function (saveElement) {
      setText(saveElement, 'Save ' + formatMoney(saveCents));
      setHidden(saveElement, saveCents <= 0);
    });
    root.querySelectorAll('[data-vpc-save-amount]').forEach(function (saveElement) {
      var variantSaveCents = Math.max(compareAtPrice - price, 0);
      setText(saveElement, formatMoney(variantSaveCents) + ' Off');
      setHidden(saveElement, variantSaveCents <= 0);
    });
    root.querySelectorAll('[data-vpc-variant-input]').forEach(function (input) {
      input.value = String(variant.id);
      input.setAttribute('value', String(variant.id));
    });
    root.querySelectorAll('[data-vpc-add-button]').forEach(function (button) {
      button.disabled = !variant.available;
      var text = button.querySelector('.atc_text, [data-button-text]');
      if (text) {
        if (!text.dataset.vpcOriginalText) text.dataset.vpcOriginalText = text.textContent.trim();
        text.textContent = variant.available ? text.dataset.vpcOriginalText : (soldOutText || text.dataset.vpcOriginalText);
      }
    });
    root.querySelectorAll('[data-vpc-current-style]').forEach(function (styleElement) {
      setText(styleElement, variant.option1 || '');
    });
    root.querySelectorAll('[data-vpc-current-option]').forEach(function (optionElement) {
      var optionName = optionElement.dataset.optionName;
      var value = state.currentPurchase
        && normalize(optionName) === state.currentPurchase.record.targetOptionNormalized
        ? state.currentPurchase.product.title
        : state.selectedOptions[optionName];
      setText(optionElement, value || '');
    });
    root.querySelectorAll('[data-vpc-rider-height]').forEach(function (heightElement) {
      var selected = heightElement.dataset.variantId
        ? heightElement.dataset.variantId === String(variant.id)
        : state.selectedOptions[heightElement.dataset.optionName] === heightElement.dataset.optionValue;
      heightElement.classList.toggle('selected', selected);
    });
    root.querySelectorAll('[data-vpc-option]').forEach(function (optionElement) {
      var optionName = optionElement.dataset.optionName;
      var optionValue = optionElement.dataset.optionValue;
      var optionState = getOptionStateForState(state, optionName, optionValue);
      var disabledByRule = isOptionDisabledByRule(optionName, optionValue, variant, config);
      var optionIndex = config.optionNames.indexOf(optionName);
      var isFirstOption = optionIndex === 0;
      var isColorOption = isColorOptionName(optionName);
      var isForcedHidden = !optionState.exists && optionState.hiddenExists;
      var shouldHide = isFirstOption || isColorOption
        ? !optionState.available
        : isForcedHidden;
      var shouldDisable = !shouldHide && (disabledByRule || !optionState.available);
      var isNativeTargetSelected = state.currentPurchase
        && normalize(optionName) === state.currentPurchase.record.targetOptionNormalized
        ? false
        : optionState.selected;

      optionElement.classList.toggle('selected', isNativeTargetSelected);
      optionElement.hidden = shouldHide;
      optionElement.classList.toggle('disabled', shouldDisable);
      optionElement.classList.toggle('available', !shouldHide && !shouldDisable);
      optionElement.classList.toggle('sold-out', shouldDisable);
      if ('disabled' in optionElement) optionElement.disabled = shouldHide || shouldDisable;
      optionElement.setAttribute('aria-checked', isNativeTargetSelected ? 'true' : 'false');
      optionElement.setAttribute('aria-hidden', shouldHide ? 'true' : 'false');
      optionElement.setAttribute('aria-disabled', shouldHide || shouldDisable ? 'true' : 'false');
      if (shouldDisable) optionElement.setAttribute('no-available', 'true');
      else optionElement.removeAttribute('no-available');
    });

    renderExtraPurchaseOptions(root, state);
  }

  function renderExtraPurchaseOptions(root, state) {
    (state.extraPurchaseRecords || []).forEach(function (record) {
      record.products.forEach(function (product) {
        var selector = '[data-vl-vpc-extra-purchase-product-id="' + String(product.id) + '"]'
          + '[data-vl-vpc-extra-purchase-target-option="' + record.targetOptionNormalized + '"]';
        var button = root.querySelector(selector);
        if (!button) return;

        var targetOptionName = findOptionNameByNormalizedValue(
          state.config.optionNames,
          record.targetOptionNormalized
        );
        if (!targetOptionName) return;
        var matches = findPurchaseFunnelVariants(
          product,
          record,
          state.config.optionNames,
          state.selectedOptions,
          state.config,
          false
        );
        var hiddenMatches = findPurchaseFunnelVariants(
          product,
          record,
          state.config.optionNames,
          state.selectedOptions,
          state.config,
          true
        );
        var targetOptionIndex = state.config.optionNames.indexOf(targetOptionName);
        var hideWhenUnavailable = targetOptionIndex === 0 || isColorOptionName(targetOptionName);
        var isForcedHidden = matches.length === 0 && hiddenMatches.length > 0;
        var available = matches.some(function (variant) { return variant.available; });
        var shouldHide = hideWhenUnavailable ? !available : isForcedHidden;
        var shouldDisable = !shouldHide && !available;
        var selected = Boolean(
          state.currentPurchase
          && state.currentPurchase.product === product
          && state.currentPurchase.record === record
        );

        button.hidden = shouldHide;
        button.disabled = shouldHide || shouldDisable;
        button.classList.toggle('selected', selected);
        button.classList.toggle('disabled', shouldDisable);
        button.classList.toggle('available', !shouldHide && !shouldDisable);
        button.classList.toggle('sold-out', shouldDisable);
        button.setAttribute('aria-checked', selected ? 'true' : 'false');
        button.setAttribute('aria-hidden', shouldHide ? 'true' : 'false');
        button.setAttribute('aria-disabled', shouldHide || shouldDisable ? 'true' : 'false');
        if (shouldDisable) button.setAttribute('no-available', 'true');
        else button.removeAttribute('no-available');
      });
    });
  }

  var HTMLElementBase = global.HTMLElement || class {};

  class VelotricProductCardVariant extends HTMLElementBase {
    connectedCallback() {
      if (this.controllerAbort) return;

      this.root = this.closest('product-card');
      var dataElement = this.querySelector('[data-variant-controller-data]');
      if (!this.root || !dataElement) return;

      try {
        this.config = JSON.parse(dataElement.textContent);
      } catch (error) {
        console.error('Invalid product card variant data', error);
        return;
      }

      var visibleVariants = getVisibleVariants(this.config.variants, this.config.hiddenVariantIds);
      var hiddenVariants = getHiddenVariants(this.config.variants, this.config.hiddenVariantIds);
      var initialVariant = normalizeInitialVariant(visibleVariants, this.config.initialVariantId);
      if (!initialVariant) return;

      this.state = {
        config: this.config,
        variants: visibleVariants,
        hiddenVariants: hiddenVariants,
        extraPurchaseRecords: prepareExtraPurchaseRecords(this.config.extraPurchaseRecords),
        selectedOptions: selectedOptionsFromVariant(this.config.optionNames, initialVariant),
        currentVariant: initialVariant,
        currentPurchase: null
      };
      this.renderExtraPurchaseButtons();
      var defaultPurchase = findDefaultExtraPurchase(
        this.state.extraPurchaseRecords,
        this.config.optionNames,
        this.state.selectedOptions,
        this.config
      );
      if (defaultPurchase) {
        this.state.currentPurchase = {
          record: defaultPurchase.record,
          product: defaultPurchase.product
        };
        this.state.selectedOptions = mergeSelectedOptionsFromPurchaseVariant(
          this.config.optionNames,
          this.state.selectedOptions,
          defaultPurchase.product,
          defaultPurchase.variant,
          defaultPurchase.record.targetOptionNormalized
        );
        this.state.currentVariant = defaultPurchase.variant;
      }
      this.controllerAbort = new AbortController();
      this.root.addEventListener('click', this.handleClick.bind(this), { signal: this.controllerAbort.signal });
      this.root.addEventListener('keydown', this.handleKeydown.bind(this), { signal: this.controllerAbort.signal });
      renderVariant(this.root, this.state);
    }

    disconnectedCallback() {
      if (this.controllerAbort) this.controllerAbort.abort();
      this.controllerAbort = null;
    }

    handleClick(event) {
      var extraPurchaseButton = event.target.closest('[data-vl-vpc-extra-purchase-product-id]');
      if (extraPurchaseButton && this.root.contains(extraPurchaseButton) && !isOptionElementDisabled(extraPurchaseButton)) {
        this.selectExtraPurchase(extraPurchaseButton);
        return;
      }
      var optionElement = event.target.closest('[data-vpc-option]');
      if (!optionElement || !this.root.contains(optionElement) || isOptionElementDisabled(optionElement)) return;
      this.selectOption(optionElement);
    }

    handleKeydown(event) {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      var extraPurchaseButton = event.target.closest('[data-vl-vpc-extra-purchase-product-id]');
      if (extraPurchaseButton && this.root.contains(extraPurchaseButton) && !isOptionElementDisabled(extraPurchaseButton)) {
        event.preventDefault();
        this.selectExtraPurchase(extraPurchaseButton);
        return;
      }
      var optionElement = event.target.closest('[data-vpc-option]');
      if (!optionElement || !this.root.contains(optionElement) || isOptionElementDisabled(optionElement)) return;
      event.preventDefault();
      this.selectOption(optionElement);
    }

    selectOption(optionElement) {
      var optionName = optionElement.dataset.optionName;
      var optionValue = optionElement.dataset.optionValue;
      var selectedOptions = applyProductRules(
        this.state.selectedOptions,
        optionName,
        optionValue,
        this.config
      );
      var purchase = this.state.currentPurchase;
      var normalizedOptionName = normalize(optionName);
      if (purchase && normalizedOptionName === purchase.record.targetOptionNormalized) {
        this.state.currentPurchase = null;
        purchase = null;
      }

      var usePurchase = Boolean(
        purchase
        && normalizedOptionName !== purchase.record.targetOptionNormalized
        && hasMappedOption(optionName, this.config.optionNames, purchase.product.optionIndexes)
      );
      var optionState = getOptionStateForState(
        this.state,
        optionName,
        optionValue,
        selectedOptions
      );
      var currentVariant = findPreferredAvailableVariant(
        optionState.matches,
        this.config.optionNames,
        optionState.selectedOptions,
        usePurchase ? purchase.product.optionIndexes : null,
        usePurchase ? purchase.record.targetOptionNormalized : null
      );
      if (!currentVariant) return;

      if (usePurchase) {
        selectedOptions = mergeSelectedOptionsFromPurchaseVariant(
          this.config.optionNames,
          optionState.selectedOptions,
          purchase.product,
          currentVariant,
          purchase.record.targetOptionNormalized
        );
      } else {
        this.state.currentPurchase = null;
        selectedOptions = selectedOptionsFromVariant(this.config.optionNames, currentVariant);
      }

      this.state.selectedOptions = selectedOptions;
      this.state.currentVariant = currentVariant;
      renderVariant(this.root, this.state);
    }

    renderExtraPurchaseButtons() {
      this.state.extraPurchaseRecords.forEach(function (record) {
        var nativeOption = Array.from(this.root.querySelectorAll('[data-vpc-option]')).find(function (option) {
          return normalize(option.dataset.optionName) === record.targetOptionNormalized;
        });
        if (!nativeOption) return;

        var host = nativeOption.closest('.option-btn-container') || nativeOption.parentElement;
        if (!host) return;
        if (!host.hasAttribute('role')) host.setAttribute('role', 'radiogroup');
        if (!host.hasAttribute('aria-label')) host.setAttribute('aria-label', record.targetOption);

        record.products.forEach(function (product) {
          var selector = '[data-vl-vpc-extra-purchase-product-id="' + String(product.id) + '"]'
            + '[data-vl-vpc-extra-purchase-target-option="' + record.targetOptionNormalized + '"]';
          if (host.querySelector(selector)) return;
          var button = document.createElement('button');
          button.type = 'button';
          button.className = 'variant-style-btn vl-product-card-extra-purchase-option';
          button.textContent = product.title;
          button.setAttribute('role', 'radio');
          button.setAttribute('aria-checked', 'false');
          button.dataset.vlVpcExtraPurchaseProductId = String(product.id);
          button.dataset.vlVpcExtraPurchaseTargetOption = record.targetOptionNormalized;
          if (product.isPurchaseFirst === true) {
            var nativeAnchor = nativeOption;
            while (nativeAnchor.parentElement && nativeAnchor.parentElement !== host) {
              nativeAnchor = nativeAnchor.parentElement;
            }
            host.insertBefore(button, nativeAnchor);
          } else {
            host.appendChild(button);
          }
        });
      }, this);
    }

    selectExtraPurchase(button) {
      var productId = button.dataset.vlVpcExtraPurchaseProductId;
      var targetOption = button.dataset.vlVpcExtraPurchaseTargetOption;
      var record = this.state.extraPurchaseRecords.find(function (item) {
        return item.targetOptionNormalized === targetOption;
      });
      if (!record) return;
      var product = record.products.find(function (item) {
        return String(item.id) === String(productId);
      });
      if (!product) return;

      var matches = findPurchaseFunnelVariants(
        product,
        record,
        this.config.optionNames,
        this.state.selectedOptions,
        this.config,
        false
      );
      var currentVariant = findPreferredAvailableVariant(
        matches,
        this.config.optionNames,
        this.state.selectedOptions,
        product.optionIndexes,
        record.targetOptionNormalized
      );
      if (!currentVariant) return;

      this.state.currentPurchase = { record: record, product: product };
      this.state.selectedOptions = mergeSelectedOptionsFromPurchaseVariant(
        this.config.optionNames,
        this.state.selectedOptions,
        product,
        currentVariant,
        record.targetOptionNormalized
      );
      this.state.currentVariant = currentVariant;
      renderVariant(this.root, this.state);
    }
  }

  global.VelotricProductCardVariant = {
    toIdSet: toIdSet,
    getVisibleVariants: getVisibleVariants,
    getHiddenVariants: getHiddenVariants,
    normalize: normalize,
    getOptionNameAliases: getOptionNameAliases,
    prepareExtraPurchaseRecords: prepareExtraPurchaseRecords,
    findDefaultExtraPurchase: findDefaultExtraPurchase,
    findMatchingPurchaseVariants: findMatchingPurchaseVariants,
    normalizeInitialVariant: normalizeInitialVariant,
    selectedOptionsFromVariant: selectedOptionsFromVariant,
    findExactVariant: findExactVariant,
    findFallbackVariant: findFallbackVariant,
    getOptionState: getOptionState,
    isColorOptionName: isColorOptionName,
    getFunnelConstraintNames: getFunnelConstraintNames,
    findFunnelVariants: findFunnelVariants,
    findPurchaseFunnelVariants: findPurchaseFunnelVariants,
    findPreferredAvailableVariant: findPreferredAvailableVariant,
    mergeSelectedOptionsFromPurchaseVariant: mergeSelectedOptionsFromPurchaseVariant,
    getOptionStateForState: getOptionStateForState,
    applyProductRules: applyProductRules,
    isOptionDisabledByRule: isOptionDisabledByRule,
    isOptionElementDisabled: isOptionElementDisabled,
    variantUrl: variantUrl,
    renderVariant: renderVariant
  };

  if (global.customElements && !global.customElements.get('velotric-product-card-variant')) {
    global.customElements.define('velotric-product-card-variant', VelotricProductCardVariant);
  }
})(typeof window !== 'undefined' ? window : globalThis);
